import React, { useEffect, useState } from "react";
import "./Dashboard.scss";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Box,
  Link,
  ToggleButton,
  ToggleButtonGroup,
  Button,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import { Chart } from "react-google-charts";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import SearchDropdown from "../../../../Supporting files/SearchDropdown/SearchDropdown";
import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsExportData from "highcharts/modules/export-data";
import HighchartsAccessibility from "highcharts/modules/accessibility";

Highcharts3D(Highcharts);
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);
HighchartsAccessibility(Highcharts);

interface Props {
  value_update: Function;
}

const Dashboard: React.FC<Props> = ({ value_update }) => {
  const [logintype, setLogintype] = useState<string | null>("endoresement");
  const [premiumValue, setPremiumValue] = useState<number | null>(null);
  const [origin, setOrigin] = useState<string>("IN");
  const [viewTabsStatus, setViewTabsStatus] = useState<string>("India");
  const changeToggle = (
    event: React.MouseEvent<HTMLElement>,
    newchangeToggle: string | null
  ) => {
    if (newchangeToggle != null) {
      setLogintype(newchangeToggle);
    }
  };
  const policyRenewal = [
    {
      class_name: "health",
      title: "Health",
      value: "124",
    },
    {
      class_name: "term",
      title: "Term",
      value: "86",
    },
    {
      class_name: "ci",
      title: "CI",
      value: "12",
    },
    {
      class_name: "pa",
      title: "PA",
      value: "04",
    },
  ];
  const alertSummary = [
    {
      class_name: "quoteicon",
      title: "Quotes",
      value: "12",
    },
    {
      class_name: "claimicon",
      title: "Claim",
      value: "86",
    },
    {
      class_name: "endoreseicon",
      title: "Endorsement",
      value: "12",
    },
  ];
  const optionsPiChart = {
    is3D: true,
    legend: "none",
  };
  const totalClients = [
    ["Total Clients", "Hours per Day"],
    ["FMCG", 11],
    ["IT", 2],
    ["Hardware", 2],
    ["Software", 2],
    ["Accounts", 7],
  ];
  const data = [
    {
      name: "Jan",
      ci: 4000,
      health: 2400,
      pa: 1400,
      term: 2400,
    },
    {
      name: "Feb",
      ci: 3000,
      health: 1398,
      pa: 1400,
      term: 2210,
    },
    {
      name: "Mar",
      ci: 2000,
      health: 9800,
      pa: 1400,
      term: 2290,
    },
    {
      name: "Apr",
      ci: 2780,
      health: 3908,
      pa: 1400,
      term: 2000,
    },
    {
      name: "May",
      ci: 1890,
      health: 4800,
      pa: 1400,
      term: 2181,
    },
    {
      name: "Jun",
      ci: 2390,
      health: 3800,
      pa: 1400,
      term: 2500,
    },
    {
      name: "Jul",
      ci: 3490,
      health: 4300,
      pa: 1400,
      term: 2100,
    },
    {
      name: "Aug",
      ci: 1890,
      health: 6800,
      pa: 1400,
      term: 2181,
    },
    {
      name: "Sep",
      ci: 3490,
      health: 4300,
      pa: 1400,
      term: 2100,
    },
    {
      name: "Oct",
      ci: 5490,
      health: 1300,
      pa: 1400,
      term: 2100,
    },
    {
      name: "Nov",
      ci: 390,
      health: 4300,
      pa: 1400,
      term: 900,
    },
    {
      name: "Dec",
      ci: 1490,
      health: 2300,
      pa: 1400,
      term: 1100,
    },
  ];
  const dataRequest = [
    {
      name: "Jan",
      Total: 3920,
      Resolved: 3400,
      Pending: 400,
      Rejected: 120,
    },
    {
      name: "Feb",
      Total: 2860,
      Resolved: 2400,
      Pending: 400,
      Rejected: 60,
    },
    {
      name: "Mar",
      Total: 4800,
      Resolved: 2400,
      Pending: 2400,
      Rejected: 200,
    },
    {
      name: "Apr",
      Total: 1920,
      Resolved: 1400,
      Pending: 400,
      Rejected: 120,
    },
    {
      name: "May",
      Total: 4800,
      Resolved: 3400,
      Pending: 1400,
      Rejected: 120,
    },
    {
      name: "Jun",
      Total: 2860,
      Resolved: 2400,
      Pending: 400,
      Rejected: 60,
    },
    {
      name: "Jul",
      Total: 4800,
      Resolved: 2400,
      Pending: 2400,
      Rejected: 120,
    },
    {
      name: "Aug",
      Total: 2860,
      Resolved: 2400,
      Pending: 400,
      Rejected: 60,
    },
    {
      name: "Sep",
      Total: 1920,
      Resolved: 1400,
      Pending: 400,
      Rejected: 120,
    },
    {
      name: "Oct",
      Total: 4800,
      Resolved: 2400,
      Pending: 2400,
      Rejected: 120,
    },
    {
      name: "Nov",
      Total: 1920,
      Resolved: 1400,
      Pending: 400,
      Rejected: 120,
    },
    {
      name: "Dec",
      Total: 4800,
      Resolved: 400,
      Pending: 4400,
      Rejected: 120,
    },
  ];

  //  Pie chart data
  const optionsDonutChart = {
    pieHole: 0.4,
    is3D: true,
    height: 400,
    legend: {
      position: "bottom",
      alignment: "center",
      textStyle: {
        color: "#666",
        fontSize: 12,
      },
    },
  };
  const policyTypeData: (string | number)[][] = [
    ["Task", "Hours per Day"],
    ["Health", 6],
    ["Term", 2],
    ["PA", 9],
    ["CI", 11],
  ];
  const premiumPolicyData: (string | number)[][] = [
    // ["Task", "Hours per Day"],
    ["Health", 1500],
    ["Term", 3000],
    ["Super Topup", 4000],
    ["Travel", 5000],
    ["Personal Accident", 6000],
    ["Critical Illness", 5500],
  ];
  useEffect(() => {
    let total = 0;
    for (let i = 1; i < premiumPolicyData.length; i++) {
      if (typeof premiumPolicyData[i][1] === "number") {
        total += Number(premiumPolicyData[i][1]);
      }
    }
    setPremiumValue(total);
  }, []);
  const countryDropData = [
    { label: "IN", value: "IN" },
    { label: "US", value: "US" },
    { label: "CA", value: "CA" },
  ];
  const UsStates = [
    ["State", "Clients"],
    ["Alabama", 40],
    ["Alaska", null],
    ["American Samoa", 50],
    ["Arizona", null],
    ["Arkansas", 44],
    ["California", 22],
    ["Colorado", null],
    ["Connecticut", 36],
    ["Delaware", null],
    ["District Of Columbia", 50],
    ["Federated States Of Micronesia", 40],
    ["Florida", null],
    ["Georgia", null],
    ["Guam", null],
    ["Hawaii", 15],
    ["Idaho", 26],
    ["Illinois", null],
    ["Indiana", 38],
    ["Iowa", null],
    ["Kansas", 25],
    ["Kentucky", 35],
    ["Louisiana", null],
    ["Maine", 30],
    ["Marshall Islands", 40],
    ["Maryland", null],
    ["Massachusetts", null],
    ["Michigan", 10],
    ["Minnesota", null],
    ["Mississippi", 10],
    ["Missouri", 44],
    ["Montana", null],
    ["Nebraska", 45],
    ["Nevada", 33],
    ["New Hampshire", null],
    ["New Jersey", 22],
    ["New Mexico", null],
    ["New York", null],
    ["North Carolina", 10],
    ["North Dakota", 20],
    ["Northern Mariana Islands", null],
    ["Ohio", null],
    ["Oklahoma", 42],
    ["Oregon", 44],
    ["Palau", null],
    ["Pennsylvania", null],
    ["Puerto Rico", 50],
    ["Rhode Island", 30],
    ["South Carolina", null],
    ["South Dakota", null],
    ["Tennessee", null],
    ["Texas", null],
    ["Utah", null],
    ["Vermont", null],
    ["Virgin Islands", null],
    ["Virginia", null],
    ["Washington", null],
    ["West Virginia", null],
    ["Wisconsin", null],
    ["Wyoming", null],
  ];
  const CanadaStates = [
    ["State", "Clients"],
    ["Alberta", 12],
    ["British Columbia", 20],
    ["Manitoba", null],
    ["New Brunswick", null],
    ["Newfoundland and Labrador", 15],
    ["Nova Scotia", null],
    ["Northwest Territories", 5],
    ["Nunavut", null],
    ["Ontario", 24],
    ["Prince Edward Island", null],
    ["Québec", null],
    ["Saskatchewan", null],
    ["Yukon", null],
  ];
  const IndStates = [
    ["State", "Clients"],
    ["Andhra Pradesh", null],
    ["Arunachal Pradesh", null],
    ["Assam", null],
    ["Bihar", null],
    ["Chhattisgarh", 62],
    ["Goa", 58],
    ["Gujarat", 54],
    ["Haryana", 30],
    ["Himachal Pradesh", 35],
    ["Jharkhand", 41],
    ["Jammu and Kashmir", 20],
    ["Karnataka", null],
    ["Kerala", null],
    ["Madhya Pradesh", null],
    ["Maharashtra", null],
    ["Manipur", null],
    ["Meghalaya", null],
    ["Mizoram", 10],
    ["Nagaland", 38],
    ["Odisha", 45],
    ["Punjab", 40],
    ["Rajasthan", 68],
    ["Sikkim", 66],
    ["Tamil Nadu", 64],
    ["Telangana", null],
    ["Tripura", null],
    ["Uttar Pradesh", 54],
    ["Uttarakhand", 50],
    ["West Bengal", null],
    ["Delhi", 30],
  ];

  const optionsGeoChart = {
    region: origin, // Display US states
    domain: origin,
    displayMode: "regions",
    tooltip: { isHtml: true, trigger: "both" }, // Display tooltip on hover and selection
    resolution: "provinces", // Show state boundaries
    defaultColor: "#ffffff",
    regionStyle: {
      border: "1px solid #FFE1A7", // Set border style
      borderRadius: 20, // Set border radius
    },
    colorAxis: {
      colors: [
        "#e5ef88", // Light color, likely representing lower values.
        "#d4b114", // A middle color, representing intermediate values.
        "#e85a03", // Dark color, representing higher values.
      ],
    },
  };
  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };

  useEffect(() => {
    // (Highcharts as any).chart('policy_type_pie_chart', {
    //   chart: {
    //     type: 'pie',
    //     options3d: {
    //       enabled: true,
    //       alpha: 40,
    //     },
    //   },
    //   plotOptions: {
    //     pie: {
    //       innerSize: 100,
    //       depth: 45,
    //     },
    //   },
    //   series: [
    //     {
    //       name: 'Policy',
    //       data: policyTypeData,
    //     },
    //   ],
    //   tooltip: {
    //     pointFormat: ' <b>{point.percentage:.1f}%</b>',
    //   },
    // });
    (Highcharts as any).chart("premium_policy_pie_chart", {
      chart: {
        type: "pie",
        options3d: {
          enabled: true,
          alpha: 40,
        },
      },
      plotOptions: {
        pie: {
          innerSize: 100,
          depth: 45,
        },
      },
      series: [
        {
          name: "Premium Amount",
          data: premiumPolicyData,
        },
      ],
      tooltip: {
        pointFormat: "<b>Rs.{point.y}</b>", // Display Rs. before each value in the tooltip
      },
    });
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid xs={12}>
        <h3 className="mb-0">Dashboard</h3>
      </Grid>
      <Grid xs={9} className="pl-0">
        <Grid container spacing={3}>
          <Grid xs={4}>
            <Grid
              container
              alignItems="center"
              className="totalClients"
              spacing={0}
            >
              <Grid xs={12} className="pl-2">
                <h3>1,086</h3>
                <p>Total Clients</p>
                <span className="charts">
                  <Chart
                    chartType="PieChart"
                    data={totalClients}
                    options={optionsPiChart}
                    width={"150px"}
                    height={"150px"}
                  />
                </span>
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={4}>
            <Grid
              container
              alignItems="center"
              className="activePolicies"
              spacing={0}
            >
              <Grid xs={6} className="pl-2">
                <h3>4,946</h3>
                <p>Active Policies</p>
              </Grid>
              <Grid xs={6} className="pr-4">
                <ul>
                  <li className="health">Health</li>
                  <li className="term">Term</li>
                  <li className="ci">CI</li>
                  <li className="pa">PA</li>
                </ul>
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={4}>
            <Grid container className="noofLives" spacing={0}>
              <Grid xs={12} className="totalLives">
                <img src="./images/noof_lives.png" alt="img" />
                <span>
                  <h3>1,836</h3>
                  <p>No. of Lives</p>
                </span>
              </Grid>
              <Grid xs={6} className="pl-2">
                <h5>1,068</h5>
                <p>Employees</p>
              </Grid>
              <Grid xs={6} className="pl-4">
                <h5>768</h5>
                <p>Dependents</p>
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={12}>
            <h4>Policies</h4>
            <ResponsiveContainer width="100%" height={400}>
              <BarChart barSize={15} data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="term" stackId="a" fill="#580DE0" />
                <Bar dataKey="health" stackId="a" fill="#576CEF" />
                <Bar dataKey="pa" stackId="a" fill="#F3B03D" />
                <Bar dataKey="ci" stackId="a" fill="#E45C8B" />
              </BarChart>
            </ResponsiveContainer>
          </Grid>
          <Grid xs={12} xl={6} textAlign={"center"} className="mt-2">
            <Box
              borderRadius={5}
              padding={3}
              sx={{ background: "rgba(107, 98, 220, 0.1)" }}
            >
              <h4 className="mb-0">Policy Type as %</h4>
              <span className="policytypeas">
                {/* <div id="policy_type_pie_chart"></div> */}
                <Chart
                  chartType="PieChart"
                  width="100%"
                  data={policyTypeData}
                  options={optionsDonutChart}
                />
              </span>
              <div
                style={{
                  textAlign: "center",
                  color: "#8e8e93",
                  fontWeight: 600,
                }}
              >
                Total Policies - 4946
              </div>
            </Box>
          </Grid>
          <Grid xs={12} xl={6} textAlign={"center"} className="mt-2">
            <Box
              borderRadius={5}
              padding={3}
              sx={{ background: "rgba(107, 98, 220, 0.1)" }}
            >
              <h4 className="mb-0">Premium Policy </h4>
              <span className="policytypeas">
                <div id="premium_policy_pie_chart"></div>
              </span>
              <div
                style={{
                  textAlign: "center",
                  color: "#8e8e93",
                  fontWeight: 600,
                }}
              >
                Total Premium Rs. {premiumValue}
              </div>
            </Box>
          </Grid>
          <Grid xs={12}>
            <Box>
              <Grid container alignItems="center">
                <Grid xs={12} padding={0}>
                  <h4 className="m-0 pb-3">
                    Client Geographical Representation
                  </h4>
                </Grid>
                <Grid xs={12} lg={5} xl={4} className="pl-0">
                  <div className="productTabs ">
                    <Button
                      style={{ padding: "10px 30px" }}
                      className={
                        viewTabsStatus == "India"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        setViewTabsStatus("India");
                        setOrigin("IN");
                      }}
                    >
                      India
                    </Button>
                    <Button
                      style={{ padding: "10px 30px" }}
                      className={
                        viewTabsStatus == "World"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        setViewTabsStatus("World");
                      }}
                    >
                      Different Region
                    </Button>
                  </div>
                </Grid>
                {viewTabsStatus == "World" ? (
                  <Grid xs={12} lg={4} xl={3} className="pl-0">
                    <SearchDropdown
                      class_name="inputField"
                      title="Choose Country"
                      value={origin}
                      attrName={setOrigin}
                      value_update={updateMasterState}
                      data={countryDropData}
                      warn_status={false}
                      error_message="Please select client"
                    />
                  </Grid>
                ) : null}
              </Grid>
              {viewTabsStatus == "India" ? (
                <>
                  <span className="policytypea">
                    <Chart
                      chartType="GeoChart"
                      width="100%"
                      data={IndStates}
                      options={optionsGeoChart}
                    />
                  </span>
                </>
              ) : null}
              {viewTabsStatus == "World" ? (
                <>
                  <span className="policytypea">
                    <Chart
                      chartType="GeoChart"
                      width="100%"
                      data={
                        origin === "US"
                          ? UsStates
                          : origin === "CA"
                          ? CanadaStates
                          : IndStates
                      }
                      options={optionsGeoChart}
                    />
                  </span>
                </>
              ) : null}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid xs={6}>
            <h4 className="mb-0">Requests</h4>
          </Grid>
          <Grid xs={6} className="text-right">
            <ToggleButtonGroup
              className="loginTypeToggle"
              value={logintype}
              size="small"
              exclusive
              onChange={changeToggle}
            >
              <ToggleButton value="claim">Claim</ToggleButton>
              <ToggleButton value="endoresement">Endorsement</ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Grid xs={12}>
            <ResponsiveContainer width="100%" height={400}>
              <BarChart barSize={15} data={dataRequest}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="Rejected" stackId="a" fill="#EB5757" />
                <Bar dataKey="Pending" stackId="a" fill="#847DD6" />
                <Bar dataKey="Resolved" stackId="a" fill="#66D1BD" />
                <Bar dataKey="Total" fill="none" />
              </BarChart>
            </ResponsiveContainer>
          </Grid>
        </Grid>
      </Grid>

      <Grid xs={3}>
        <Grid container spacing={3}>
          <Grid xs={12}>
            <div className="alertMessage">
              <InfoIcon />
              <h5>Critical CD Balance</h5>
              <ul>
                <li>Evervent - ₹ 10,000</li>
                <li>Quickbima - ₹ 15,000</li>
                <li>Domain - ₹ 8,000</li>
                <li>Example - ₹ 10,000</li>
                <li>Evervent - ₹ 10,000</li>
                <li>Quickbima - ₹ 15,000</li>
                <li>Domain - ₹ 8,000</li>
                <li>Example - ₹ 10,000</li>
              </ul>
              <Link>
                <CloseIcon />
              </Link>
            </div>
          </Grid>
          <Grid xs={12} className="todolist mb-0">
            <h4>To Do</h4>
            <Link underline="none" className="addpolicy">
              Upload your clients
            </Link>
            <Link underline="none" className="addpolicy">
              Upload employees
            </Link>
            <Link underline="none" className="riskscore">
              Set Report Preferences
            </Link>
            <Link underline="none" className="familyprofile">
              Review Access Controls
            </Link>
          </Grid>
          <Grid xs={12}>
            <Box className="policyRenewal">
              <div className="thisMonth">Next 45 Days</div>
              <h3>486</h3>
              <p>Upcoming Renewals</p>
              <ul>
                {policyRenewal.map((data, index) => (
                  <li className={data.class_name}>
                    <span>{data.value}</span> {data.title}
                  </li>
                ))}
              </ul>
            </Box>
          </Grid>
          <Grid xs={12}>
            <Box className="alertSummary">
              <h3>Alert Summary</h3>
              <p>Total pendings of quote, claim & endorsement.</p>
              <ul>
                {alertSummary.map((data, index) => (
                  <li>
                    <div className={data.class_name}></div>
                    <p>
                      {data.title} <span>{data.value}</span>
                    </p>
                  </li>
                ))}
              </ul>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
